export default "__VITE_ASSET__66bb8af3__"